<li class="topNavItem"
	[id]="id"
	(keydown.enter)="openAndClose()"
	[class.active]="isActive()">
	@if (hasChildren()) {
		<a (click)="openAndClose()"
		   tabindex="0"
		   #anchor
		   bas-anchor-status
		   [parameters]="item.parameters"
		   class="nav-item top">
			<span>{{ item.name || (item.nameKey | msgKey) }}</span>
		</a>
	} @else {
		<a (click)="openAndClose()"
		   tabindex="0"
		   #anchor
		   bas-anchor-status
		   [parameters]="item.parameters"
		   [routerLink]="item.url"
		   [queryParams]="item.query"
		   class="nav-item top">
			<span>{{ item.name || (item.nameKey | msgKey) }}</span>
		</a>
	}
	@if (hasChildren()) {
		<ul [@openState]="state">
			<bas-nav-sub-item-level-1 *ngFor="let subItem of item.children"
									  [item]="subItem"
									  [counter]="1"
									  (itemClick)="close()"></bas-nav-sub-item-level-1>
		</ul>
	}
</li>
